import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NewsList } from '../../model/news.model';
import { NewsAdapter } from './news.adapter';

@Injectable()
export class NewsConnector {
  constructor(protected adapter: NewsAdapter) {}

  get(start: number, count: number): Observable<NewsList> {
    return this.adapter.load(start, count);
  }

  getByType(start: number, count: number, newsType: string): Observable<NewsList> {
    return this.adapter.loadByType(start, count, newsType);
  }

  getByYear(start: number, count: number, newsYear: string): Observable<NewsList> {
    return this.adapter.loadByYear(start, count, newsYear);
  }

  getByTypeAndYear(start: number, count: number, newsType: string, newsYear: string): Observable<NewsList> {
    return this.adapter.loadByTypeAndYear(start, count, newsType, newsYear);
  }
}
